/**
 * Sample page JS provided here for extension. Might not be useful if all JS is based on components.
 */

class PageHome extends DrupalBehavior {
}

DrupalBehavior.register('camc.pages', 'home', PageHome);
